<template>
  <div
    class="wrapper log-bg overflow-hidden pagination pagination-relative"
    v-if="data"
    id="playerlist"
  >
    <Menu />
    <div class="body-area">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="team-list d-flex section--demo-2">
              <div class="glide" id="topcarousel">
                <div class="glide__track" data-glide-el="track">
                  <ul class="glide__slides">
                    <li class="glide__slide" v-for="(item, index) in data" :key="index">
                      <div
                        class="team-list-item eurolig slider-box position-relative"
                        :class="index == activeItem ? 'active' : ''"
                      >
                        <h1 class="fs-18 fc-5">
                          {{item.name}}
                          <br />
                          <span class="fs-24">Takım Kadrosu</span>
                        </h1>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="data[activeItem].isSub == 0">
          <div class="col-12">
            <div class="player-list d-flex self-end" style="margin-top: 0px">
              <div class="glide" id="bottomcarousel">
                <div class="glide__track" data-glide-el="track">
                  <ul class="glide__slides">
                    <li
                      class="glide__slide"
                      v-for="(item, index) in data[activeItem].players"
                      :key="index"
                    >
                      <div
                        class="player-list-item col-10"
                        @click="goProfile(item.id);"
                        style="display: flex;
    align-items: center;
    justify-content: center;"
                      >
                        <img
                          style="    height: 57vh;
    z-index: 99;
    position: relative;
    margin-bottom: 70px;border-bottom: 4px solid red;"
                          :src="$store.state.baseImageURL + 'img/player/' + $store.state.app.yearslug + '/' + item.jerseyNo + '/body.png'"
                        />
                        <div
                          class="player-box text-center"
                          style="    position: absolute;
    bottom: 0px;
    height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(100% - 50px);
    padding-top: 100px;
    z-index: 98;"
                        >
                          <div
                            class="player-name fs-28 fc-2 rbs"
                            style="margin: 0; font-size: 20px"
                          >{{item.name}}</div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="data[activeItem].isSub == 1">
          <div class="col-12">
            <div class="player-list-young">
              <div
                class="player-block bg-2"
                v-for="(item, index) in data[activeItem].players"
                :key="index"
              >
                <div class="player">
                  <div class="text-center number-area">
                    <h1 class="fs-20 fc-6 form-number">{{ item.jerseyNo }}</h1>
                  </div>
                  <div class="player-detail">
                    <div class="row">
                      <h1 class="fs-20 fc-2 col-12 font-weight-normal player-name">
                        {{item.name
                        }}
                      </h1>
                    </div>
                    <div class="row">
                      <div class="col-3">
                        <span class="fs-11 fc-2">Pozisyon</span>
                        <span class="fs-18 fc-1">{{item.position}}</span>
                      </div>
                      <div class="col-3">
                        <span class="fs-11 fc-2">Yaş</span>
                        <span
                          class="fs-18 fc-1"
                        >{{moment().diff(item.birthDate.date, 'years', false)}}</span>
                      </div>
                      <div class="col-3">
                        <span class="fs-11 fc-2">Boy</span>
                        <span class="fs-18 fc-1">{{item.height}}</span>
                      </div>
                      <div class="col-3">
                        <span class="fs-11 fc-2">Doğum Yeri</span>
                        <span class="fs-18 fc-1">{{item.birthPlace}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
import axios from "axios";
import Glide from "@glidejs/glide";
import moment from "moment";

export default {
  name: "Team",
  components: {
    Menu,
    Header,
    Footer
  },
  data() {
    return {
      data: null,
      activeItem: 0,
      moment
    };
  },
  methods: {
    goProfile(id) {
      this.$store.state.loading = true;

      axios.get("takim/oyuncu?player=" + id).then(res => {
        this.$store.state.loading = false;

        this.$router.push({
          name: "Player",
          params: { slug: res.data.data.slug, data: res.data.data }
        });
      });
    },
    pageChanged(index) {
      this.activeItem = index;
    }
  },
  beforeMount() {
    axios.get("takim").then(res => {
      this.data = res.data.data;
      setTimeout(() => {
        this.topCarousel = new Glide("#topcarousel", {
          peek: { before: 0, after: 70 }
        }).mount();

        this.bottomCarousel = new Glide("#bottomcarousel", {
          peek: { before: 0, after: 70 }
        }).mount();

        this.topCarousel.on(["move.after", "run"], () => {
          this.activeItem = this.topCarousel.index;
        });
      });
    });
  },
  watch: {
    activeItem: function() {
      if (this.activeItem == 0) {
        setTimeout(() => {
          this.bottomCarousel = new Glide("#bottomcarousel", {
            peek: { before: 0, after: 70 }
          }).mount();
        }, 200);
      }
    }
  }
};
</script>

<style>
#playerlist .slider-box::before {
  content: "" !important;
  display: none !important;
}

#playerlist .VueCarousel {
  width: 100%;
}

.team-list .team-list-item.eurolig {
  padding: 25px 31px 17px;
  padding-right: 0px;
  padding-left: 20px;
}

.glide__track {
  overflow: unset;
}
</style>


// WEBPACK FOOTER //
// src/pages/Team.vue